import { render, staticRenderFns } from "./data_statistics.vue?vue&type=template&id=a62ba4c4&"
import script from "./data_statistics.vue?vue&type=script&lang=js&"
export * from "./data_statistics.vue?vue&type=script&lang=js&"
import style0 from "./data_statistics.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports